export enum LocalStorageKey {
  token = 'token',
}
